<template>
    <div v-if="isVisible">
        <!-- <hr/> -->
        <!-- <div class="loginInfo"> -->
        <!-- <p>会员姓名：{{ loginMbName }}</p>
        <p>会员编号：{{ loginMbNo }}</p>
        <p>会员身份：{{ loginMbType }}</p>
        <p>手机号码：{{ loginPhone  }}</p> -->
        <!-- <p>登录时间：{{ formattedTime }}</p> -->
        <!-- </div> -->
        <div class="vip-card">
            <div class="card-header">
                <h3>会员信息</h3>
            </div>
            <div class="card-body">
                <div class="logo-container"><img src="https://www.shaklee.com.cn/images/favicon.ico" alt="VIP Logo" class="vip-logo"></div>
                <div class="member-info">
                    <p><strong>会员姓名：</strong>{{ loginMbName }}</p>
                    <p><strong>会员编号：</strong>{{ loginMbNo }}</p>
                    <p><strong>会员身份：</strong>{{ loginMbType }}</p>
                    <p><strong>手机号码：</strong>{{ loginPhone  }}</p>
                </div>
            </div>
        </div>
        <!-- <hr/> -->
        <p class="loginTitle"> {{ loginFishedTitle }}... <span v-if="jumpDown>0">{{ jumpDownTxt }}</span> </p>
        <div class="jumpzone" >
            <!-- 如果3秒内没有自动跳转到嘉康利商城，请手动点击 <a :href="jumpUrl">立即跳转</a> -->
             <!-- <span v-if="jumpDown>0">{{ jumpDown }}</span> -->
        </div>
        <div>
            <el-button @click="refreshPage" class="agree-btn" >重新登录</el-button>
            <el-button @click="toMall" class="agree-btn" >前往商城</el-button>
        </div>
    </div>
</template>

<script>
export default {
    props: ['loginFishedTitle', 'isVisible', 'loginMbNo', 'loginMbName', 'loginMbType', 'loginPhone', 'jumpUrl'],

    data() {
        return {
            jumpDownTxt:'3',
            jumpDown:3, //n秒后跳转,
            showToMall:false,
            jumpInterval:null,
        }
    },
    computed: {
        // formattedTime() {
        //     const now = new Date();
        //     const hours = now.getHours();
        //     const minutes = now.getMinutes();
        //     const seconds = now.getSeconds();
        //     return `${hours}:${minutes}:${seconds}`;
        // }
    },
    updated() {
        this.startJumpTimer();
    },
    beforeDestroy() {
        this.clearJumpTimer();
    },
    
    // updated() {
    //     if (this.loginPhone && this.jumpUrl) {
    //         const jumpInterval = setInterval(() => {
    //             if (this.jumpDown > 0) {
    //                 // console.log('即将跳转' + this.jumpDown);
    //                 this.jumpDown--;
    //             } else {
    //                 clearInterval(jumpInterval);
    //                 this.jumpDown = 0;
    //                 // console.log('即将跳转' + this.jumpUrl);
    //                 window.location.href = this.jumpUrl;
    //                 // this.showToMall = true;
    //                 // alert(this.loginPhone);
    //             }
    //         }, 800);
    //     }
    // },
    methods: {
        toMall() {
            // window.history.forward();
            if (!this.showToMall) {
                return;
            }
            const mallUrl = 'http://t.weimob.com/CW_hY2';
            this.performRedirect(mallUrl);
        },
        refreshPage() {
            location.reload();
        },
        startJumpTimer() {
            if (this.jumpInterval) {
                this.clearJumpTimer();
            }

            this.jumpInterval = setInterval(() => {
                if (this.jumpDown > 0) {
                    this.jumpDown--;
                    this.jumpDownTxt = `${this.jumpDown}`;
                } else {
                    this.jumpDownTxt = '';
                    this.clearJumpTimer();
                    this.showToMall = true;
                    this.performRedirect(this.jumpUrl);
                }
            }, 800); // 每秒减少一次倒计时
        },
        clearJumpTimer() {
            if (this.jumpInterval) {
                clearInterval(this.jumpInterval);
                this.jumpInterval = null;
            }
        },
        performRedirect(jumpUrl) {
            window.location.href = jumpUrl;
        },
    }
}

</script>
<style scoped>
.loginInfo {
    width: 80%;
    padding-left: 20%;
    text-align: left;
    line-height: 0.8;
}
.loginTitle {
    color:#173f35; 
    font-size: 18px;
    text-decoration:double;
}
.jumpzone{
    padding-left: 45%;
    font-size: 12px;
    text-align: left;
}

.vip-card {
    width: 96%;
    background-color: #fff;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    text-align: center;
    margin-left: 2%;
    margin-top: 100px;
}

.card-header {
    background-color: #308A78; 
    color: #fff;
    padding: 1px;
    font-size: 18px;
    font-weight: bold;
}

.card-body {
    padding: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.logo-container {
    margin-right: 20px;
}
.vip-logo {
    width: 50px;
    height: 45px;
    margin-bottom: 20px;
}
.member-info {
    text-align: left;
    margin-bottom: 10px;
    flex-grow: 1
}

.member-info p {
    margin: 5px 0;
    font-size: 16px;
}

.card-footer {
    background-color: #f8f8f8;
    padding: 10px;
    font-size: 14px;
    color: #555;
}

.agree-btn {
	margin-top: 1.2rem;
	margin-bottom: 1rem;
	width: 8em;
	height: 40px;
	border-radius: 25px;
	border: none;
	background-color: #3ca389; 
	color: #fff;
	align-self: center;
}
</style>


// WEBPACK FOOTER //
// src/page/LoginSucess.vue